import AddWordingsState from './addWordingsState/AddWordingsState';
import React from 'react';
import InputFields from './components/InputFields/InputFields';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

const AddWordingsPage: React.FC = () => {
	return (
		<AddWordingsState>
			<div className={style.container}>
				<InputFields />
				<ModalWindows />
			</div>
		</AddWordingsState>
	);
};

export default AddWordingsPage;
